import React, { useEffect } from "react";
import Breadcrumbs from "../../common/breadcrumbs";
import { useState } from "react";
import { USERS_TABS } from "../../../config/configs";
import OnboardedUsers from "./OnboardedUsers";
import { Tab, Tabs } from "react-bootstrap";
import PendingUsers from "./PendingUsers";
import GuestUsers from "./GuestUsers";
import Referrals from "./Referrals";
import { useLocation, useNavigate } from "react-router";
import { URL } from "../../../constants/URL";

const Users = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [activeTab, setActiveTab] = useState();
	const handleChangeTab = (val) => {
		setActiveTab(val);
		switch (val) {
			case USERS_TABS.ONBOARDED:
				navigate(URL.onboarderedUsers);
				break;
			case USERS_TABS.PENDING:
				navigate(URL.pendingRegistration);
				break;
			case USERS_TABS.GUEST:
				navigate(URL.guestUsers);
				break;
			case USERS_TABS.REFERRALS:
				navigate(URL.referrals);
				break;
			default:
				navigate(URL.onboarderedUsers);
				break;
		}
	};

	useEffect(() => {
		switch (location.pathname) {
			case URL.onboarderedUsers:
				setActiveTab(USERS_TABS.ONBOARDED);
				break;
			case URL.pendingRegistration:
				setActiveTab(USERS_TABS.PENDING);
				break;
			case URL.guestUsers:
				setActiveTab(USERS_TABS.GUEST);
				break;
			case URL.referrals:
				setActiveTab(USERS_TABS.REFERRALS);
				break;
			default:
				setActiveTab(USERS_TABS.ONBOARDED);
				break;
		}
	}, [location.pathname]);

	return (
		<React.Fragment>
			<Breadcrumbs title="Users Management" data={[{ label: "Users" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="card notification-card tabs-block p-0">
						<Tabs
							className="pl-5 pt-3 tab-block"
							id="controlled-tab-example"
							activeKey={activeTab}
							onSelect={handleChangeTab}
						>
							<Tab eventKey={USERS_TABS.ONBOARDED} title={USERS_TABS.ONBOARDED}>
								<OnboardedUsers />
							</Tab>
							<Tab eventKey={USERS_TABS.PENDING} title={USERS_TABS.PENDING}>
								<PendingUsers />
							</Tab>
							<Tab eventKey={USERS_TABS.GUEST} title={USERS_TABS.GUEST}>
								<GuestUsers />
							</Tab>
							<Tab eventKey={USERS_TABS.REFERRALS} title={USERS_TABS.REFERRALS}>
								<Referrals />
							</Tab>
						</Tabs>
					</div>
					{/* </div> */}
					{/* {activeTab === USERS_TABS.ONBOARDED && <OnboardedUsers />} */}
				</div>
			</div>
		</React.Fragment>
	);
};
export default Users;
